





















































































































import Vue from 'vue';
import { BankPreAccDimCode } from "../models/BankPreAccEditing";
import IconButton from '@/components/IconButton.vue';
import MoneyDisplay from '@/components/MoneyDisplay.vue';
import store, { BankPreAccEditorStore } from "../services/BankPreAccEditorStore";
import LookupComboBox from "@/components/LookupComboBox.vue";
import eventBus from '@/services/eventBus';
import { t } from "@/plugins/i18n";

interface Data {
  store: BankPreAccEditorStore;
  totalTemp: number;
}

interface Methods {
  onRowClick(item: any): void;
  confirmDeletion(item: any): void;
  dimCodes(dimCodeType: number): BankPreAccDimCode[];
  onDimCodeValueChanged(item: any, newValue: any): void;
  onValueChanged(item: any): void;
  itemCurrency(item: any): string | undefined;
}

interface Computed {
  totalDisplay: string;
}

interface Props {
  dataItems: any[];
  dimColumns: any;
  dimCodeType: number;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  data() {
    return {
      store,
      totalTemp: 0,
    };
  },
  methods: {
    onRowClick(item) {
      this.totalTemp = item.dataItem.total;
      this.$emit("onRowClick", item);
    },
    confirmDeletion(item) {
      this.$emit("dimDelete", item);
      item.deleting = false;
    },
    // A kontír-dimenziókód lookup az évre szűrt mmbokdimcode lista; a type
    // itt a csaccdimcodetype (5..13), a mentett érték a SZÖVEGES kód.
    dimCodes(dimCodeType) {
      return this.store.dimCodes.filter((i: BankPreAccDimCode) => i.type == dimCodeType);
    },
    onDimCodeValueChanged(item, newValue) {
      if (store.dimensionsRows.filter(x => x.head == item.head && x.dimCodeType == item.dimCodeType && x.id != item.id).some(i => i.dimCode == newValue.dimcode)) {
        eventBus.$emit("error", t("Transactions_LetezikMarIlyenDimenziokoduTetel"));
      } else {
        item.dimCode = newValue.dimcode;
      }
    },
    onValueChanged(item) {
      this.store.syncDimensionModified(item);
    },
    itemCurrency(item) {
      return store.items.find(x => x.id == item.head)?.currency ?? store.head.currency;
    }
  },
  computed: {
    totalDisplay: {
      get() {
        return this.totalTemp
          ? new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 2 }).format(this.totalTemp)
          : '';
      },
      set(val) {
        const normalized = val
          .replace(/\s/g, '')
          .replace(',', '.');
        const numeric = parseFloat(normalized);

        this.totalTemp = Number(numeric);
      }
    }
  },
  props: {
    dataItems: {
      type: Array as () => any[],
      required: true
    },
    dimColumns: {
      type: Array as () => any[],
      required: true
    },
    dimCodeType: {
      type: Number,
      required: true
    }
  },
  components: {
    IconButton,
    MoneyDisplay,
    LookupComboBox
  }
});
